import { render, staticRenderFns } from "./perfordeperdatFil.vue?vue&type=template&id=54acf1a2&scoped=true&"
import script from "./perfordeperdatFil.vue?vue&type=script&lang=js&"
export * from "./perfordeperdatFil.vue?vue&type=script&lang=js&"
import style0 from "./perfordeperdatFil.vue?vue&type=style&index=0&id=54acf1a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54acf1a2",
  null
  
)

export default component.exports